import React from 'react';
import {Header, Form} from 'semantic-ui-react';
import _ from 'lodash';

import {REQUEST_DETAILS_VALUE_CHANGE_DISPLAY} from 'app-ui-componentlibrary/dist/common/constants';
import {toItemCode, displayError} from 'common/requestDetails/utils';
import {InlineSelect} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {EXPLAIN_OTHER, EXPLAIN_OTHER_ITEM} from 'common/requestDetails/constants.js';
import {TextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';

export const HeaderSection = ({
  disableFields,
  expanded,
  handleBlur,
  handleItemChange,
  handleItemChangeAndBlur,
  id,
  itemCodeOptions,
  item: lineItem,
  itemConfig,
  validationDirtyMap,
  validationErrors,
}) => {
  let isExpanded = expanded !== undefined ? expanded : true;
  let itemName = _.get(itemConfig, 'name', '');
  let isReadOnly = _.get(itemConfig, 'labels.type', '') === 'readOnly' ? true : false;
  const ITEM_COST_CODE = 'itemCode';
  const explainOtherLabel = 'Other description';
  const itemCostCodeLabel = _.upperFirst(
    _.get(
      itemConfig,
      'labels.itemLabel',
      REQUEST_DETAILS_VALUE_CHANGE_DISPLAY[ITEM_COST_CODE]
    )
  );

  const itemOtherDescriptionLabel = _.upperFirst(
    _.get(
      itemConfig,
      'labels.otherDescription',
      REQUEST_DETAILS_VALUE_CHANGE_DISPLAY[ITEM_COST_CODE]
    )
  );

  const otherExplainPath = EXPLAIN_OTHER;
  const itemCostCodePath = ITEM_COST_CODE;
  const itemCost = _.get(lineItem, 'itemCode');
  const explainOther = _.get(lineItem, otherExplainPath);
  let descriptionErrors = displayError(
    EXPLAIN_OTHER,
    EXPLAIN_OTHER,
    validationErrors,
    validationDirtyMap
  );

  // Accounting for V2 validation format for explainOtherItem
  if (!descriptionErrors.displayError) {
    descriptionErrors = displayError(
      EXPLAIN_OTHER_ITEM,
      EXPLAIN_OTHER,
      validationErrors,
      validationDirtyMap
    );
  }

  const renderOther = () => {
    if (itemCost === 8) {
      return (
        <TextBoxField
          id={id}
          value={explainOther}
          label={explainOtherLabel}
          fieldName={EXPLAIN_OTHER}
          title={explainOtherLabel}
          expanded={isExpanded}
          maxLength={_.get(itemConfig, 'headerItemMaxLength')}
          handleChange={(e, data) => handleItemChange(EXPLAIN_OTHER, data.value)}
          handleBlur={() => handleBlur(EXPLAIN_OTHER)}
          errorMessages={descriptionErrors.errorMessages}
          displayError={descriptionErrors.displayError}
          rows={2}
        />
      );
    }
    return null;
  };

  const showTextbox =
    itemCost === 8 &&
    itemCodeOptions !== undefined &&
    itemCodeOptions.length === 1 &&
    _.findIndex(itemCodeOptions, {key: '8'}) >= 0;

  const renderTextBox = () => {
    return (
      <div className="app-form-row margin-bottom-25">
        <div className="app-form-block _80">
          {expanded ? (
            <Form.Field>
              <TextBoxField
                className="util--full-width"
                value={explainOther}
                label={itemOtherDescriptionLabel}
                id={`${EXPLAIN_OTHER}-${id}`}
                title={itemOtherDescriptionLabel}
                name={EXPLAIN_OTHER}
                maxLength={_.get(itemConfig, 'headerItemMaxLength')}
                errorMessages={descriptionErrors.errorMessages}
                displayError={descriptionErrors.displayError}
                handleChange={(e, data) => handleItemChange(EXPLAIN_OTHER, data.value)}
                handleBlur={() => handleBlur(EXPLAIN_OTHER)}
              />
            </Form.Field>
          ) : (
            <Header as="h5">{explainOther}</Header>
          )}
        </div>
      </div>
    );
  };

  const renderStandard = () => {
    return (
      <div className="app-form-row margin-bottom-25">
        <div className="app-form-block _80">
          {isExpanded &&
          !_.isEmpty(itemCodeOptions) &&
          !_.includes(disableFields, 'item') &&
          showTextbox !== true ? (
            <InlineSelect
              options={itemCodeOptions}
              label={itemCostCodeLabel}
              name={itemCostCodeLabel}
              handleChange={(e) =>
                handleItemChangeAndBlur(itemCostCodePath, toItemCode(e.target.value))
              }
              value={itemCost}
            />
          ) : (
            <Header as="h5">{itemName}</Header>
          )}
          {renderOther()}
        </div>
      </div>
    );
  };

  const renderReadOnly = () => {
    return (
      <div className="app-form-row margin-bottom-25">
        <div className="app-form-block _80">
            <Header as="h5">{itemCostCodeLabel}</Header>
            <p>{itemName}</p>
        </div>
      </div>
    );
  };

  return showTextbox ? renderTextBox() : isReadOnly ? renderReadOnly() : renderStandard();
};

export default HeaderSection;
